import type { Market } from '../../types';
import type {
    GlobalFilterOverrides,
    OutcomeToDisplay,
    FiltersByOutcomeParameterMap,
    OutcomesCtids,
} from './types';
import { filterHandicap } from './filters/filterHandicap';
import { filterDefault } from './filters/filterDefault';
import { filterTotal } from './filters/filterTotal';
import { createEmptyOutcome } from './utils/createEmptyOutcome';


export const filterByMarket = (
    market: Market,
    outcomes: OutcomeToDisplay[],
    outcomesCtids: OutcomesCtids | undefined,
    filtersMap: FiltersByOutcomeParameterMap,
    globalFilterOverrides: GlobalFilterOverrides,
): OutcomeToDisplay[] => {
    const filteredOutcomes: OutcomeToDisplay[] = filterDefault(outcomes, filtersMap, globalFilterOverrides);

    switch(market.kind) {
        case 'Handicap':
            return filterHandicap(filteredOutcomes, filtersMap);

        case 'Total':
            return filterTotal(filteredOutcomes, filtersMap, market);

        case 'Winner':
            // дополняем список исходов отсутствующими исходами на основе ctid из параметров рынка
            for(const mParams of market.params) {
                if (mParams.outcomeKind === 'UNKNOWN') {
                    continue;
                }

                if (!outcomesCtids || !outcomesCtids.has(mParams.ctid)) {
                    filteredOutcomes.push(createEmptyOutcome(mParams.ctid, mParams.outcomeKind, mParams.name));
                }
            }
            return filteredOutcomes.sort((a, b) => a.outcome.ctid - b.outcome.ctid);

        default:
            return filteredOutcomes;
    }    
}